import { ArrowDown, Volume2, VolumeX } from 'lucide-react';
import { useState } from 'react';
import type { WorldKind } from '@core/types';
import { AmbientScene } from './AmbientScene';
import { Logo } from './Logo';

export function EntryGate({ world, onEnter }: { world: WorldKind; onEnter: () => void }): JSX.Element {
  const [muted, setMuted] = useState(true);
  return <div className={`entry-gate world-${world}`}>
    <AmbientScene dense />
    <div className="entry-top"><Logo light /><span>COMPANION SPECIES / FIELD 001</span><button className="icon-button" onClick={() => setMuted(!muted)} aria-label={muted ? 'Enable ambient audio' : 'Mute ambient audio'}>{muted ? <VolumeX size={16} /> : <Volume2 size={16} />}</button></div>
    <div className="entry-copy">
      <p><span>MEMES.{world.toUpperCase()}</span> PRESENTS</p>
      <h1>A living thing<br />for the space <em>between.</em></h1>
      <button className="entry-button" onClick={onEnter}><span>ENTER THE HABITAT</span><i><ArrowDown size={17} /></i></button>
    </div>
    <div className="entry-foot"><span>SCROLL AFTER ENTRY</span><span>THREE.JS / GPU FIELD</span><span>LONDON · 2026</span></div>
  </div>;
}
